import React from "react";

const Wrapper = ({ heading, stepNo, question, children, description }) => {
  return (
    <div className="uk-text-center c-quiz">
      <h2 className="c-quiz_head">Pump Selector Tool</h2>
      <h1 className="c-quiz__question">{question}</h1>
      {description && <h4 className="uk-text-default">{description}</h4>}
      {children}
    </div>
  );
};
export default Wrapper;
